import * as actionTypes from '../actions/actionTypes';
import { updateObject, sortTasksArrayByDate } from '../../utils/utils';

const initialState = {
  tasks: [],
  error: '',
  loading: false,
};

// / create single task

const createTaskSingleStart = (state) => {
  return updateObject(state, { loading: true });
};

const createTaskSingleSuccess = (state) => {
  return updateObject(state, {});
};

const createTaskSingleFail = (state) => {
  return updateObject(state, { loading: false });
};

// / create regular task

const createTaskRegularStart = (state) => {
  return updateObject(state, { loading: true });
};

const createTaskRegularSuccess = (state) => {
  return updateObject(state, {});
};

const createTaskRegularFail = (state) => {
  return updateObject(state, { loading: false });
};

// / create Delayed task

const createTaskDelayedStart = (state) => {
  return updateObject(state, { loading: true });
};

const createTaskDelayedSuccess = (state) => {
  return updateObject(state, {});
};

const createTaskDelayedFail = (state) => {
  return updateObject(state, { loading: false });
};

// / create global task

const createTaskGlobalStart = (state) => {
  return updateObject(state, { loading: true });
};

const createTaskGlobalSuccess = (state) => {
  return updateObject(state, {});
};

const createTaskGlobalFail = (state) => {
  return updateObject(state, { loading: false });
};

// / update single task

const updateTaskSingleStart = (state) => {
  return updateObject(state, { loading: true });
};

const updateTaskSingleSuccess = (state) => {
  return updateObject(state, {});
};

const updateTaskSingleFail = (state) => {
  return updateObject(state, { loading: false });
};

// / update regular task

const updateTaskRegularStart = (state) => {
  return updateObject(state, { loading: true });
};

const updateTaskRegularSuccess = (state) => {
  return updateObject(state, {});
};

const updateTaskRegularFail = (state) => {
  return updateObject(state, { loading: false });
};

// / update Delayed task

const updateTaskDelayedStart = (state) => {
  return updateObject(state, { loading: true });
};

const updateTaskDelayedSuccess = (state) => {
  return updateObject(state, {});
};

const updateTaskDelayedFail = (state) => {
  return updateObject(state, { loading: false });
};

// / update global task

const updateTaskGlobalStart = (state) => {
  return updateObject(state, { loading: true });
};

const updateTaskGlobalSuccess = (state) => {
  return updateObject(state, {});
};

const updateTaskGlobalFail = (state) => {
  return updateObject(state, { loading: false });
};

// / remove single task

const removeTaskSingleStart = (state) => {
  return updateObject(state, { loading: true });
};

const removeTaskSingleSuccess = (state) => {
  return updateObject(state, {});
};

const removeTaskSingleFail = (state) => {
  return updateObject(state, { loading: false });
};

// / remove regular task

const removeTaskRegularStart = (state) => {
  return updateObject(state, { loading: true });
};

const removeTaskRegularSuccess = (state) => {
  return updateObject(state, {});
};

const removeTaskRegularFail = (state) => {
  return updateObject(state, { loading: false });
};

// / remove Delayed task

const removeTaskDelayedStart = (state) => {
  return updateObject(state, { loading: true });
};

const removeTaskDelayedSuccess = (state) => {
  return updateObject(state, {});
};

const removeTaskDelayedFail = (state) => {
  return updateObject(state, { loading: false });
};

// / remove global task

const removeTaskGlobalStart = (state) => {
  return updateObject(state, { loading: true });
};

const removeTaskGlobalSuccess = (state) => {
  return updateObject(state, {});
};

const removeTaskGlobalFail = (state) => {
  return updateObject(state, { loading: false });
};

const getTasksServerStart = (state) => {
  return updateObject(state, { loading: true });
};

const getTasksServerSuccess = (state, action) => {
  return updateObject(state, { loading: false, tasks: sortTasksArrayByDate(action.payload.tasks) });
};

const getTasksServerFail = (state) => {
  return updateObject(state, { loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_TASK_SINGLE_START:
      return createTaskSingleStart(state, action);
    case actionTypes.CREATE_TASK_SINGLE_SUCCESS:
      return createTaskSingleSuccess(state, action);
    case actionTypes.CREATE_TASK_SINGLE_FAIL:
      return createTaskSingleFail(state, action);

    case actionTypes.CREATE_TASK_REGULAR_START:
      return createTaskRegularStart(state, action);
    case actionTypes.CREATE_TASK_REGULAR_SUCCESS:
      return createTaskRegularSuccess(state, action);
    case actionTypes.CREATE_TASK_REGULAR_FAIL:
      return createTaskRegularFail(state, action);

    case actionTypes.CREATE_TASK_DELAYED_START:
      return createTaskDelayedStart(state, action);
    case actionTypes.CREATE_TASK_DELAYED_SUCCESS:
      return createTaskDelayedSuccess(state, action);
    case actionTypes.CREATE_TASK_DELAYED_FAIL:
      return createTaskDelayedFail(state, action);

    case actionTypes.CREATE_TASK_GLOBAL_START:
      return createTaskGlobalStart(state, action);
    case actionTypes.CREATE_TASK_GLOBAL_SUCCESS:
      return createTaskGlobalSuccess(state, action);
    case actionTypes.CREATE_TASK_GLOBAL_FAIL:
      return createTaskGlobalFail(state, action);

    case actionTypes.UPDATE_TASK_SINGLE_START:
      return updateTaskSingleStart(state, action);
    case actionTypes.UPDATE_TASK_SINGLE_SUCCESS:
      return updateTaskSingleSuccess(state, action);
    case actionTypes.UPDATE_TASK_SINGLE_FAIL:
      return updateTaskSingleFail(state, action);

    case actionTypes.UPDATE_TASK_REGULAR_START:
      return updateTaskRegularStart(state, action);
    case actionTypes.UPDATE_TASK_REGULAR_SUCCESS:
      return updateTaskRegularSuccess(state, action);
    case actionTypes.UPDATE_TASK_REGULAR_FAIL:
      return updateTaskRegularFail(state, action);

    case actionTypes.UPDATE_TASK_DELAYED_START:
      return updateTaskDelayedStart(state, action);
    case actionTypes.UPDATE_TASK_DELAYED_SUCCESS:
      return updateTaskDelayedSuccess(state, action);
    case actionTypes.UPDATE_TASK_DELAYED_FAIL:
      return updateTaskDelayedFail(state, action);

    case actionTypes.UPDATE_TASK_GLOBAL_START:
      return updateTaskGlobalStart(state, action);
    case actionTypes.UPDATE_TASK_GLOBAL_SUCCESS:
      return updateTaskGlobalSuccess(state, action);
    case actionTypes.UPDATE_TASK_GLOBAL_FAIL:
      return updateTaskGlobalFail(state, action);

    case actionTypes.REMOVE_TASK_SINGLE_START:
      return removeTaskSingleStart(state, action);
    case actionTypes.REMOVE_TASK_SINGLE_SUCCESS:
      return removeTaskSingleSuccess(state, action);
    case actionTypes.REMOVE_TASK_SINGLE_FAIL:
      return removeTaskSingleFail(state, action);

    case actionTypes.REMOVE_TASK_REGULAR_START:
      return removeTaskRegularStart(state, action);
    case actionTypes.REMOVE_TASK_REGULAR_SUCCESS:
      return removeTaskRegularSuccess(state, action);
    case actionTypes.REMOVE_TASK_REGULAR_FAIL:
      return removeTaskRegularFail(state, action);

    case actionTypes.REMOVE_TASK_DELAYED_START:
      return removeTaskDelayedStart(state, action);
    case actionTypes.REMOVE_TASK_DELAYED_SUCCESS:
      return removeTaskDelayedSuccess(state, action);
    case actionTypes.REMOVE_TASK_DELAYED_FAIL:
      return removeTaskDelayedFail(state, action);

    case actionTypes.REMOVE_TASK_GLOBAL_START:
      return removeTaskGlobalStart(state, action);
    case actionTypes.REMOVE_TASK_GLOBAL_SUCCESS:
      return removeTaskGlobalSuccess(state, action);
    case actionTypes.REMOVE_TASK_GLOBAL_FAIL:
      return removeTaskGlobalFail(state, action);

    case actionTypes.GET_TASKS_SERVER_START:
      return getTasksServerStart(state, action);
    case actionTypes.GET_TASKS_SERVER_SUCCESS:
      return getTasksServerSuccess(state, action);
    case actionTypes.GET_TASKS_SERVER_FAIL:
      return getTasksServerFail(state, action);

    default:
      return state;
  }
};

export default reducer;
